<template>
  <b-modal ref="modal" class="modal-removal" centered @hidden="onModalHidden">
    <template slot="modal-header">
      <h1
        v-if="tracks && tracks.length > 1"
      >{{Translations.sections.boxes.removeTracks.titlePlural}} {{ box ? box.name : '' }}</h1>
      <h1
        v-if="tracks && tracks.length <= 1"
      >{{Translations.sections.boxes.removeTracks.titleSingle}} {{ box ? box.name : '' }}</h1>
    </template>
    <template>
      <transition name="fade" mode="out-in">
        <div>
          <h2
            v-if="tracks && tracks.length > 1"
            class="modal-content-title"
          >{{Translations.sections.boxes.removeTracks.textPlural}}</h2>
          <h2
            v-if="tracks && tracks.length <= 1"
            class="modal-content-title"
          >{{Translations.sections.boxes.removeTracks.textSingle}}</h2>
        </div>
      </transition>
    </template>
    <template slot="modal-footer">
      <Button
        :empty="true"
        class="close-popup"
        @click.prevent="hide"
      >{{ Translations.buttons.cancel }}</Button>
      <Button
        :empty="false"
        class="validate"
        @click.prevent="removeTracks"
      >{{ tracks && tracks.length > 1 ? Translations.buttons.doDeleteTracks.plural : Translations.buttons.doDeleteTracks.single }}</Button>
    </template>
  </b-modal>
</template>

<script>
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Apis from "@/apis/index";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";
import ArtistBadgeList from "@/components/common/ArtistBadgeList";
import TextInput from "@/components/common/TextInput";
import DurationText from "@/components/common/DurationText";

export default {
  name: "BoxTrackRemovalCard",
  store,
  components: {
    Portlet,
    Bootstrap,
    Button,
    WaitingBlock,
    ArtistBadgeList,
    TextInput,
    DurationText
  },
  props: ["tracks", "box"],
  computed: {
    ...mapState(["currentStation", "editedBox"]),
    Translations: function() {
      return Translations;
    },
    errorMessages: function(inputName) {
      if (this.creationResponse == null || this.creationResponse.errors == null)
        return [];
    }
  },
  watch: {
    currentStation: function() {
      console.log("station changed");
    },
    tracks: function(tracks) {
      this.tracks = tracks;
    }
  },
  data() {
    return {
      modalState: {
        show: true,
        visible: true,
        isLoadingTracks: true,
        isDeletingTracks: false,
        hasDeleteError: false,
        hasLoadingError: false
      },
      trackUids: null,
      trackData: null,
      deleteResponse: null
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    removeTracks() {
      if (this.tracks.length > 1) {
        this.unlinkTracks();
      } else {
        this.unlinkTrack();
      }
    },
    async unlinkTrack() {
      try {
        console.log(this.tracks[0]);
        const response = await HTTP.post(
          Apis.boxes.unlinkTrack,
          {
            stationUid: this.currentStation.uid,
            boxUid: this.box.uid,
            recordUid: this.tracks[0].linkData.recordUid
          }
        );
        console.log("response unlink track :", response);
        EventBus.$emit("onBoxTrackRecordsRemoved", [this.tracks[0].linkData.recordUid]);
        this.hide();
        //await this.$store.dispatch('Boxes/getTrackList', {
        //  stationUid: this.currentStation.uid,
        //  boxUid: this.box.uid,
        //});
        // load boxes to have the new count
        //await this.$store.dispatch('loadStationBoxes', this.currentStation.uid)
      } catch (e) {
        console.log("error unlink track :", e);
      }
    },
    async unlinkTracks() {
      const recordUids = this.tracks.map(track => {
        return track.linkData.recordUid;
      });

      try {
        const response = await HTTP.post(
          Apis.boxes.unlinkTracks,
          {
            stationUid: this.currentStation.uid,
            boxUid: this.box.uid,
            recordUids: recordUids
          }
        );
        EventBus.$emit("onBoxTrackRecordsRemoved", recordUids);
        EventBus.$emit("reFreshLeftMenu");

        // Do not reload the list, otherwise the user looses the pagination
        // if(response.status === 200){
        //   await this.$store.dispatch('Boxes/getTrackList', {
        //     stationUid: this.currentStation.uid,
        //     boxUid: this.box.uid,
        //   });
        // }
        this.hide();
      } catch (e) {
        console.log("error unlink tracks :", e);
      }
    },
    onModalHidden() {
      //EventBus.$emit('onBoxRemovalEnded');
    }
  }
};
</script>

<style scoped>
</style>
